export const clearObject = <T extends Record<string, unknown>>(
  object: T
): T => {
  Object.keys(object).forEach((key) => {
    if (object[key] === undefined) {
      delete object[key];
    }
  });

  return object;
};
